import { Amplify } from 'aws-amplify';
import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito';

import { env } from './env';

/**
 * Configure AWS Amplify v6 for Cognito authentication.
 * Must be called once at app startup, before any auth call.
 */
export function configureAmplify(): void {
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: env.cognito.userPoolId,
        userPoolClientId: env.cognito.clientId,
      },
    },
  });
}

/**
 * Switch token storage between localStorage (persist across sessions)
 * and sessionStorage (cleared when browser closes — "Recordarme" unchecked).
 *
 * Must be called before signIn so the token provider uses the right storage
 * from the moment tokens are written.
 */
export function setRememberMe(remember: boolean): void {
  const storage = remember ? window.localStorage : window.sessionStorage;
  cognitoUserPoolsTokenProvider.setKeyValueStorage({
    setItem: (key, value) => {
      storage.setItem(key, value);
      return Promise.resolve();
    },
    getItem: (key) => Promise.resolve(storage.getItem(key)),
    removeItem: (key) => {
      storage.removeItem(key);
      return Promise.resolve();
    },
    clear: () => {
      storage.clear();
      return Promise.resolve();
    },
  });
}
